import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import GrabMaps, { Marker as GrabMarker } from '@geo/grab-maps';
import { getMapTilesURL } from 'constants/app-constants';
import pickUpPinSvg from 'public/images/pick-up-pin.svg';

const GrabMap = GrabMaps({
  dragRotate: false,
});

const ZOOM_LEVEL = {
  FAR: 11,
  NEAR: 13,
};

const AddressMap = ({ latlng }) => {
  const centerCoordinates =
    latlng && latlng.latitude && latlng.longitude
      ? [latlng.longitude, latlng.latitude]
      : undefined;

  return (
    <GrabMap
      mapStyle={getMapTilesURL()}
      center={centerCoordinates}
      zoom={centerCoordinates ? ZOOM_LEVEL.NEAR : ZOOM_LEVEL.FAR}
      fitBoundsOptions={{
        offset: [30, 30],
      }}
    >
      {latlng && (
        <GrabMarker
          coordinates={[latlng.longitude, latlng.latitude]}
          anchor="bottom"
          className={cx('mapboxgl-marker', 'mapboxgl-marker-anchor-bottom')}
        >
          <img alt="pickup" src={pickUpPinSvg} />
        </GrabMarker>
      )}
    </GrabMap>
  );
};

AddressMap.propTypes = {
  latlng: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }).isRequired,
};

export default AddressMap;
